import Header from '../components/Header';
import Footer from '../components/Footer';
import AuthRequiredLink from '../components/AuthRequiredLink';
import { usePageInit } from '../hooks/usePageInit';
import './NotFoundPage.css';

export default function NotFoundPage() {
  usePageInit();
  return (
    <div className="m-application theme--light transition-page" id="app">
      <div className="loading"></div>
      <div className="m-content joker joker-var" id="main-wrap">
        <div className="dedicated-page">
          <Header invert={true} />
          <div className="error-wrap">
            <section className="container max-lg">
              <div className="row">
                <div className="col-md-5">
                  <div className="flex">
                    <div className="deco">
                      <div className="artwork">
                        <svg width="218px" height="220px" viewBox="0 0 218 220" version="1.1">
                          <defs>
                            <linearGradient id="linearGradient-1" x1="133.772602%" y1="-75.1506777%" x2="21.5997463%" y2="63.260628%">
                              <stop stopColor="#00BCD4" offset="0%"></stop>
                              <stop stopColor="#673AB7" offset="100%"></stop>
                            </linearGradient>
                          </defs>
                          <g id="Page-1" stroke="none" strokeWidth="0" fill="none">
                            <path
                              id="Path"
                              d="M176.484827,177.458465 C132.792561,207.953068 56.006152,234.998281 25.7115142,210.452625 C-15.7311505,176.958554 -0.783796157,131.166659 26.4613814,56.0799491 C46.757789,0.239832833 59.6555061,-25.9055394 163.187181,34.8837009 C235.62436,77.3761797 231.125156,139.365208 176.484827,177.458465 Z"
                              fill="url(#linearGradient-1)"
                              fillRule="nonzero"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <h3>404</h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-7">
                  <div className="text">
                    <h4 className="display-1">This page could not be found.</h4>
                    <p>You can either stay and chill here, or go back to the beginning.</p>
                    <AuthRequiredLink className="btn secondary waves-effect btn-large button" to="/">
                      back to home
                    </AuthRequiredLink>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <Footer invert={true} />
        </div>
      </div>
    </div>
  );
}
